import { businessKey } from 'queryKeys';

export const AUDIT_LOG = 'audit-log';
const auditLogQuery = businessKey.query(AUDIT_LOG);

export const grids = auditLogQuery.grids();
export const grid = auditLogQuery.grid();

export const mutations = auditLogQuery.mutations();

export const exportAuditLogs = mutations.mutate('export');
